import React, { Component } from 'react'
import { HeaderData } from '../../../../screens/reporting/styles';

export class PhonenumberModalHeader extends Component {
  render() {
    const { filterCloseOnClick } = this.props;
    return (
        <HeaderData>
            <h6>Buy</h6>
            <div onClick={filterCloseOnClick} style={{ cursor: 'pointer', zIndex: '999' }}>
                <span class="material-symbols-outlined">
                    cancel
                </span>
            </div>

        </HeaderData>
    )
}
}

export default PhonenumberModalHeader


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/PhonenumberModalHeader.js